import {FC} from 'react';

interface Props {}

const HomeIcon: FC<Props> = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 14.5005H2V7.9605L8 2.8175L14 7.9605V14.5005H11V9.7505C11 9.0615 10.439 8.5005 9.75 8.5005H6.25C5.561 8.5005 5 9.0615 5 9.7505V14.5005ZM7 14.5005H9V10.5005H7V14.5005ZM6.25 16.5005H1C0.448 16.5005 0 16.0535 0 15.5005V7.5005C0 7.2085 0.127 6.9315 0.349 6.7415L7.349 0.7415C7.724 0.4195 8.276 0.4195 8.651 0.7415L15.651 6.7415C15.873 6.9315 16 7.2085 16 7.5005V15.5005C16 16.0535 15.552 16.5005 15 16.5005H9.75H6.25Z"
        fill="#444444"
      />
      <mask id="mask0_5350_8872" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 14.5005H2V7.9605L8 2.8175L14 7.9605V14.5005H11V9.7505C11 9.0615 10.439 8.5005 9.75 8.5005H6.25C5.561 8.5005 5 9.0615 5 9.7505V14.5005ZM7 14.5005H9V10.5005H7V14.5005ZM6.25 16.5005H1C0.448 16.5005 0 16.0535 0 15.5005V7.5005C0 7.2085 0.127 6.9315 0.349 6.7415L7.349 0.7415C7.724 0.4195 8.276 0.4195 8.651 0.7415L15.651 6.7415C15.873 6.9315 16 7.2085 16 7.5005V15.5005C16 16.0535 15.552 16.5005 15 16.5005H9.75H6.25Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5350_8872)"></g>
    </svg>
  );
};

export default HomeIcon;
